import axios from 'axios';

const api = axios.create({
  baseURL: 'https://wavetechservices.in/api/user',
});

// Add auth token if available
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const createBooking = (bookingData) => api.post('/bookings', bookingData);
export const updateFCMToken = (userId, fcmToken, isAdmin = false) => 
  api.post('/notifications/token', { userId, fcmToken, isAdmin });